import React from "react";

import { IconProps } from "../../types/common";

const AlertIcon = ({
  width = "24",
  height = "24",
  style,
  className,
  fillClassName,
  fillColor = "#BF5C0B",
}: IconProps) => (
  <svg
    style={style}
    width={width}
    height={height}
    aria-hidden="true"
    viewBox="0 0 24 24"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fillColor!}
      className={fillClassName}
      d="M19 16.8L20.3 18C20.9 18.7 20.5 19.8 19.6 19.8H4.4C3.5 19.8 3.1 18.7 3.7 18L5 16.8V10.8C5 7.4 7.4 4.6 10.5 3.9V2.8C10.5 1.9 11.2 1.3 12 1.3 12.8 1.3 13.5 1.9 13.5 2.8V3.9C16.6 4.6 19 7.4 19 10.8V16.8ZM14 20.8C14 21.9 13.1 22.8 12 22.8 10.9 22.8 10 21.9 10 20.8H14ZM11 15.8V13.8H13V15.8H11ZM12 11.8C12.6 11.8 13 11.3 13 10.8V8.8C13 8.2 12.6 7.8 12 7.8 11.5 7.8 11 8.2 11 8.8V10.8C11 11.3 11.5 11.8 12 11.8Z"
    />
  </svg>
);

export default AlertIcon;
